import React from 'react'
import Fragment from '../common/fragment'


function FragmentCF(props) {
  return (
    <Fragment pos="fff" {...props}>
      <p>
Las llamas de las Chimeneas son fogatas que gigantes friolentos encendieron por
la noche.
      </p>
    </Fragment>
  )
}


export default FragmentCF
